import {
    ForgotPasswordFormFields,
    IForgotPasswordForm,
    ILoginForm,
    IResetPasswordForm,
    LoginFormFields,
    ResetPasswordFormFields,
} from '../interfaces';

export const emptyLoginForm: ILoginForm = {
    [LoginFormFields.username]: '',
    [LoginFormFields.password]: '',
};

export const emptyForgotPasswordForm: IForgotPasswordForm = {
    [ForgotPasswordFormFields.email]: '',
};

export const emptyResetPasswordForm: IResetPasswordForm = {
    [ResetPasswordFormFields.password]: '',
    [ResetPasswordFormFields.passwordReEntry]: '',
};
